enum ActionsWithoutReloadEnum {
  change_value = 'change_value',
  include_increase_decrease = 'include_increase_decrease',
  change_date = 'change_date',
  approve_disapprove = 'approve_disapprove',
  change_comment = 'change_comment',
}

export default ActionsWithoutReloadEnum;
